export function openTierUpgradeDialog() {
    document.getElementById('btnGlobalUpgradeTier')?.click()
}
